import autocomplete from '../autocomplete/autocomplete';
export default function searchPage() {
    autocomplete({ elementID: 'search-page-autocomplete' });
}
searchPage();
//# sourceMappingURL=search-page.js.map